module.exports = __webpack_public_path__ + "img/icon-06-subscriptionAsset 12.c1c4ae20.svg";